export default {
  en: 'LOADING...',
  ar: 'جاري التحميل...'
};
